

<div class="page-padding">
  <div class="panel">

    <div class="panel__header">
      <span class="panel__header__title">{{'Lookup' | translate | async}}</span>
    </div>
          <div class="step-container">
            <div class="margin-bottom-24">
              <mat-card class = "panel_search mat-card" >
                <form class="example-form">
                <mat-form-field class="example-full-width" >
                <mat-select  name="jobrole_"  placeholder="{{'Job Role' | translate | async}}" [(ngModel)]="jobroleID" (selectionChange)="resetMenu1andMenu2()" >
                  <mat-option (click)="onClear()" >{{'None' | translate | async}}</mat-option>  
                  <mat-option *ngFor="let jobrole of jobRoleList" [value]="jobrole.Id" (click)="getJobRole(); GetUserTable();getMenuforSelectedJobrole()">
                  {{jobrole.Name}}</mat-option>
                </mat-select>
               </mat-form-field>

              
              <mat-form-field class="example-full-width">
                <input matInput placeholder="{{'Role Name' | translate | async}}" type="text" [(ngModel)]="roleName" name = "roleName" required>
              </mat-form-field>

              <mat-form-field class="example-full-width">
                <input matInput placeholder="{{'Created By' | translate | async}}" type="text" [(ngModel)]="createdBy" name ="createdby" [readonly]="!!createdBy" >
              </mat-form-field>

              <mat-form-field class="example-full-width">
                <mat-label>{{'Role Notes' | translate | async}}</mat-label>
                <textarea matInput [(ngModel)]="roleNotes" name ="roleNotes"></textarea>
              </mat-form-field>


              <mat-checkbox class="margin-right-16" [(ngModel)]="isActive" name ="active" ngDefaultControl>{{'Active' | translate | async}}</mat-checkbox>
              <mat-checkbox class="margin-right-16" [(ngModel)]="isAdminAllowEdit" name ="admin" ngDefaultControl>{{'Admin Role' | translate | async}}
                <button  class="info-icon" mat-icon-button matTooltip="{{'Admin Role - allows edit functions in the equipment details screen' | translate | async}}" matTooltipPosition="above">
                  <mat-icon>info</mat-icon>
                </button>
              </mat-checkbox>
              <!-- <mat-checkbox class="margin-right-16" [(ngModel)]="isCanchangeGroup" name="canchange" ngDefaultControl>{{'Can change Group'}}</mat-checkbox> -->
              <div>
                <button (click) = "addNewJobrole()" mat-raised-button [disabled]="btnDisabledAdd">{{'Add' | translate | async}}</button>
                <button (click)="updateJobrole()" mat-raised-button [disabled]="btnDisabledUpdate" >{{'Update Roles' | translate | async}}</button>
                <button (click) = "deleteJobrole()"mat-raised-button [disabled]="btnDisabledDelete" >{{'Delete' | translate | async}}</button>
                <button mat-raised-button (click)="resetFields()" >{{'Reset' | translate | async}}</button>
                <!-- <button mat-raised-button (click)="resetFields()" >{{'Reset' | translate | async}}</button> -->
              </div>
              </form>
             </mat-card>    
            </div>           
        </div>
        <div class="panel__header">
          <span class="panel__header__title">{{'Job Role Permissions' | translate | async}}</span>
          
        </div>
        
        <div class="margin-bottom-24">
          <mat-card>
            <button mat-raised-button (click)="updateMenu()">{{'Update Permissions' }}</button>
            <div style=" display: flex;flex-direction: row;">
              <!-- <mat-list class="header-form-full-width"  >
    <mat-list-item *ngFor="let m1 of menuL1"  >
      <span matLine>{{m1.Name}}
      <mat-icon style="vertical-align: middle;"  *ngIf="m1.Name === 'Undercarriage '||
      m1.Name === 'Field Inspections'||
      m1.Name === 'Get & Wear Surfaces'||
      m1.Name === 'CRC'||
      m1.Name === 'Training'||
      m1.Name === 'Admin'||
      m1.Name === 'TTadmin'||
      m1.Name === 'Safety' ||
      m1.Name === 'My Account'"  (click)="clickMenulinkOne(m1)" style="transform: rotate(90deg)" >touch_app</mat-icon></span>
    <div>

      <mat-checkbox [(ngModel)]="m1.Active" (ngModelChange)="updateAllComplete()"></mat-checkbox>
    </div>
    </mat-list-item>
  </mat-list> -->


              <mat-list class="header-form-full-width">
                <mat-list-item *ngFor="let m1 of menuL1">
                  <span matLine>
                    {{m1.Name}}
                    <!-- <ng-container *ngFor="let menu2 of menuL2" >    -->
                    <mat-icon *ngIf="showicon(m1)" (click)="clickMenulinkOne(m1)" style="vertical-align: middle; transform: rotate(90deg)">touch_app</mat-icon>
                    <!-- </ng-container> -->
                  </span>
                  <div>
                    <mat-checkbox [(ngModel)]="m1.Active" (ngModelChange)="updateAllComplete()"></mat-checkbox>
                  </div>
                </mat-list-item>
              </mat-list>


              <!-- <mat-list class="header-form-full-width"  >
    <mat-list-item *ngFor="let m2 of menuL2_">
      <span matLine>  {{m2.Name}}
      <mat-icon style="vertical-align: middle;" *ngIf="m2.Name === 'Inspections'||
      m2.Name === 'Reports'||
      m2.Name === 'Setup'||
      m2.Name === 'WRSE'||
      m2.Name === 'GET Inspections'||
      m2.Name === 'Undercarriage' ||
      m2.Name === 'Components' ||
      m2.Name === 'Equipment'||
      m2.Name === 'Inductions'||
      m2.Name === 'Home' ||
      m2.Name === 'Observations'||
      m2.Name === 'Safety Forms'" (click) = "clickMenulinkTwo(m2)" style="transform: rotate(90deg)">touch_app</mat-icon></span>
      <div>
        <mat-checkbox [(ngModel)]="m2.Active" (ngModelChange)="updateAllComplete()"></mat-checkbox>
      </div>
    </mat-list-item>
  </mat-list> -->

              <mat-list class="header-form-full-width">
                <mat-list-item *ngFor="let m2 of menuL2_">
                  <span matLine>
                    {{m2.Name}}
                    <mat-icon *ngIf="showicon_(m2)" (click)="clickMenulinkTwo(m2)" style="vertical-align: middle; transform: rotate(90deg)">touch_app</mat-icon>
                  </span>
                  <div>
                    <mat-checkbox [(ngModel)]="m2.Active" (ngModelChange)="updateAllComplete()"></mat-checkbox>
                  </div>
                </mat-list-item>
              </mat-list>

              <mat-list class="header-form-full-width">
                <mat-list-item *ngFor="let m3 of menuL3_">
                  <span matLine>   {{m3.Name}}</span>
                  <div>
                    <mat-checkbox [(ngModel)]="m3.Active" (ngModelChange)="updateAllComplete()"></mat-checkbox>
                  </div>
                </mat-list-item>
              </mat-list>
              
            </div>
           
          </mat-card>
        </div>
       
        <div>
          <mat-card>
           <mat-table [dataSource]="dataSource" matSort class="mat-elevation-z8"style=" margin: 5px; "  >
             
              <ng-container matColumnDef="UserName">
                <mat-header-cell  *matHeaderCellDef mat-sort-header>{{'User Name' | translate | async}}</mat-header-cell>
                <mat-cell *matCellDef="let element"><div class="SerialAndUnitText">{{element.UserName | aesDecrypt}}</div></mat-cell>
              </ng-container>
            
              <ng-container matColumnDef="Name">
                <mat-header-cell  *matHeaderCellDef mat-sort-header> {{'Name' | translate | async}}</mat-header-cell>
                <mat-cell *matCellDef="let element"><div class="SerialAndUnitText">{{element.Name | aesDecrypt}}</div></mat-cell>
              </ng-container>
             
              <ng-container matColumnDef="startDate">
                <mat-header-cell *matHeaderCellDef mat-sort-header>{{'Start Date' | translate | async}}</mat-header-cell>
                <mat-cell *matCellDef="let element">{{element.startDate}}</mat-cell>
              </ng-container>
            
              
              <!-- <ng-container matColumnDef="endDate">
                <mat-header-cell *matHeaderCellDef mat-sort-header>{{'End Date' | translate | async}}</mat-header-cell>
                <mat-cell *matCellDef="let element">{{element.endDate}}</mat-cell>
              </ng-container> -->
            
          
              <ng-container matColumnDef="Active">
                <mat-header-cell *matHeaderCellDef mat-sort-header>{{'Active' | translate | async}}</mat-header-cell>
                <mat-cell *matCellDef="let element">{{element.Active}}</mat-cell>
              </ng-container>  
                  
              <mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>
              <mat-row *matRowDef="let row; columns: displayedColumns;" (click)="selection.toggle(row)"></mat-row>
            </mat-table>
            <!-- <mat-paginator [pageSizeOptions]="[50, 100, 200]" showFirstLastButtons></mat-paginator> -->
          </mat-card>
          </div>   
  </div>
    </div>
